import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { isNull } from 'lodash';
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import SaveIcon from '@material-ui/icons/Save';
import RefreshIcon from '@material-ui/icons/Refresh';
import { lzCallApi } from '../../../../../../services/LzApiService';
import { lzGetRecordByComparison } from '../../../../../../services/LzType';
import { lzShowErrorMessage, lzShowSuccessMessage } from '../../../../../../services/LzUtils';
import OrderFormOtherInfo from './other-Info';
import OrderFormPackagingDetails from './packaging-details';
import OrderFormShippingDetails from './shipping-details';
import OrderFormPrintSendOptions from './print-send-options';
import OrderFormShippingRates from './shipping-rates';

function OrderForm(props) {

  const [existsId, setExistsId] = useState(0);
  const [orderNo, setOrderNo] = useState(0);
  const [distributors, setDistributors] = useState([]);
  const [savedRecord, setSavedRecord] = useState(null);
  const [otherInfo, setOtherInfo] = useState(null);
  const [currData, setCurrData] = useState(null);
  const [printType, setPrintType] = useState('full');
  const [isDataChanged, setIsDataChanged] = useState(false);
  const [addingEmailAddress, setAddingEmailAddress] = useState('');
  const [addingEmailAction, setAddingEmailAction] = useState('cc');

  useEffect(() => {
    if (+props.recordId > 0) {
      loadOrderByRecordId(+props.recordId);
    }
  }, [props.recordId]);

  useEffect(() => {
    setIsDataChanged(JSON.stringify(savedRecord) !== JSON.stringify(currData));
    // console.log(JSON.stringify(savedRecord));
    // console.log(JSON.stringify(currData));
    // console.log(JSON.stringify(savedRecord) !== JSON.stringify(currData));
  }, [savedRecord, currData]);

  const loadOrderByRecordId = async (recordId) => {
    loadOrder({ id: recordId });
  };

  const loadOrderByOrderNo = async () => {
    loadOrder({ order_id: orderNo });
  };

  const loadOrder = async (params) => {
    setExistsId(0);
    const data = await lzCallApi('load-order', params);
    if (data) {
      if (data.exists) {
        setExistsId(+data.exists);
        return;
      }

      if (!data.distributors || !data.order_items || data.order_items.length < 1) {
        lzShowErrorMessage('Order data not sufficient.');
        return;
      }

      setDistributors(data.distributors);
      const savedRecord = Object.assign({}, data.saved_record);
      setSavedRecord(savedRecord);
      setOtherInfo({
        product_code: data.order_items[0].code,
        product_name: data.order_items[0].name,
        customer_name: data.customer_name,
        customer_email: data.customer_email,
      });
      const emails = data.saved_record?.emails ? data.saved_record.emails.slice() : [
        { email: data.customer_email, action: 'to', checked: true },
      ];
      if (typeof data.rma_label_notif_email !== 'undefined' && !isNull(data.rma_label_notif_email) && data.rma_label_notif_email !== '') {
        emails.push({ email: data.rma_label_notif_email, action: 'cc', checked: true });
      }
      // If in edit mode then set saved order as current data, else create it with default values
      setCurrData(props.isEdit ? savedRecord : {
        id: +(data.saved_record?.id || 0),
        order_id: +(data.saved_record?.order_id || 0),
        customer_name: data.saved_record?.customer_name || data.customer_name,
        customer_phone: data.saved_record?.customer_phone || data.customer_phone,
        customer_company: data.saved_record?.customer_company || data.customer_company,
        width: +(data.saved_record?.width || data.order_items[0].width),
        length: +(data.saved_record?.length || data.order_items[0].length),
        height: +(data.saved_record?.height || data.order_items[0].height),
        weight: +(data.saved_record?.weight || data.order_items[0].weight),
        distributor_id: +(data.saved_record?.distributor_id || 0),
        customer_address: data.customer_address,
        ffl_address: data.ffl_address,
        ship_from: data.saved_record?.ship_from || data.customer_address,
        ship_to: data.saved_record?.ship_to || '',
        rma_number: data.saved_record?.rma_number || '',
        instructions: data.saved_record?.instructions || 'Please return merchandise in original packaging.  Do not mark on or destroy any of the original contents.  Please return the packing slip you received with the original shipment to help identify the item.\n\nAll returned merchandise should be boxed & shipped in such a way that the merchandise will be in sale-able condition.',
        emails: emails,
        shipment_id: data.saved_record?.shipment_id || '',
        rates: data.saved_record?.rates ? data.saved_record.rates.slice() : [],
        rate_id: data.saved_record?.rate_id || '',
        label_url: data.saved_record?.label_url || '',
      });
      setOrderNo(+(data.saved_record?.order_id || 0));
    }
  };

  const saveRecord = async (someData) => {
    const data = await lzCallApi('save-order', someData || currData, 'post');
    if (data) {
      setSavedRecord(Object.assign({}, data));
      setCurrData(Object.assign({}, data));
    }
  };

  const easyPostCreateShipment = async () => {
    const data = await lzCallApi('easypost-create-shipment', { id: +(currData.id || 0) });
    if (data && data.shipment_id && data.rates) {
      const updated = Object.assign({}, currData, {
        shipment_id: data.shipment_id,
        rates: data.rates,
        rate_id: '',
        label_url: '',
      });
      setCurrData(updated);
      saveRecord(updated);
    }
  };

  const easyPostConfirmRateBuildLabel = async () => {
    const data = await lzCallApi('easypost-confirm-rate-build-label', { id: +(currData.id || 0) });
    if (data) {
      const updated = Object.assign({}, currData, {
        label_url: data,
      });
      setCurrData(updated);
      saveRecord(updated);
    }
  };

  const downloadLabelPDF = () => {
    lzCallApi('download-label-pdf', { id: +(currData.id || 0), printType: printType });
  };

  const sendEmails = async () => {
    const data = await lzCallApi('send-emails', { id: +(currData.id || 0), printType: printType });
    if (data) {
      lzShowSuccessMessage('Return emails are sent successfully!');
    }
  };

  const resetChanges = () => {
    setCurrData(Object.assign({}, savedRecord));
  };

  const handleCurrDataChange = (key, val) => {
    setCurrData(Object.assign({}, currData, { [key]: val }));
  };

  const handleCurrDataChanges = (changes, doSaveRecord) => {
    const updates = Object.assign({}, currData, changes);
    setCurrData(updates);
    if (doSaveRecord) {
      saveRecord(updates);
    }
  };

  const handleDistributorChange = (id) => {
    const distributor = lzGetRecordByComparison(distributors, d => +d.id === +id);

    setCurrData(Object.assign({}, currData, {
      distributor_id: +(distributor?.id || 0),
      ship_to: distributor?.address || '',
    }));
  };

  const handleEmailsChange = (act, dex, val) => {
    const emls = currData.emails.slice();

    if ('remove' === act) {
      emls.splice(dex, 1);
    }

    if ('check' === act) {
      emls[dex].checked = true;
    }

    if ('uncheck' === act) {
      emls[dex].checked = false;
    }

    if ('action' === act) {
      emls[dex].action = val;
    }

    if ('add' === act) {
      emls.push({
        email: addingEmailAddress,
        action: addingEmailAction,
        checked: true,
      });
      setAddingEmailAddress('');
    }

    const updates = Object.assign({}, currData, { emails: emls });
    setCurrData(updates);
    saveRecord(updates);
  };

  return (
    <Grid container spacing={2}>

      <Grid item sm={4}>
        <TextField required fullWidth type="number" size="small"
          label={props.isEdit || savedRecord?.id > 0 ? 'Order #' : 'Enter TGD Order #'}
          onFocus={(evt) => evt.target.select()} disabled={props.isEdit || savedRecord?.id > 0}
          value={orderNo} onChange={(evt) => setOrderNo(+evt.target.value)}
        />
      </Grid>
      <Grid item sm={8} style={{ alignContent: 'flex-end', textAlign: 'right' }}>
        {(props.isAdd && isNull(savedRecord)) &&
          <Button variant="contained" color="primary" disabled={orderNo < 1} onClick={loadOrderByOrderNo}
            startIcon={<CloudDownloadIcon />} style={{ float: 'left' }}>Load Order</Button>
        }
        <Link to="/content/orders"><Button variant="contained" color="default" startIcon={<ArrowBackIcon />}
          style={{ marginLeft: 12 }}>Back</Button></Link>
        {savedRecord?.id > 0 &&
          <React.Fragment>
            {false && isDataChanged &&
              <Tooltip placement="top" title="Reset changes you just did below, back to as they were in the saved order.">
                <Button variant="contained" color="default" startIcon={<RefreshIcon />} onClick={resetChanges}
                  style={{ marginLeft: 12 }}>Reset</Button>
              </Tooltip>
            }
            {currData?.id > 0 &&
              <Tooltip placement="top" title="Save changes here (not on your TGD account), to be able to generate labels.">
                <Button variant="contained" color="primary" startIcon={<SaveIcon />} disabled={!isDataChanged}
                  onClick={() => saveRecord()} style={{ marginLeft: 12 }}>Save</Button>
              </Tooltip>
            }
          </React.Fragment>
        }
      </Grid>

      {existsId > 0 &&
        <Grid item sm={12}>
          <Alert>Order already exists with this id. Please <Link to={'/content/orders/edit/' + existsId}>click here</Link> if you want to load this order.</Alert>
        </Grid>
      }

      {currData &&
        <React.Fragment>

          <OrderFormOtherInfo {...otherInfo} />

          <OrderFormPackagingDetails data={currData} onChange={handleCurrDataChange} />

          <OrderFormShippingDetails
            data={currData}
            distributors={distributors}
            onChange={handleCurrDataChange}
            onDistributorChange={handleDistributorChange}
          />

          {((!savedRecord || savedRecord.id < 1) && currData.width > 0 && currData.length > 0 && currData.height > 0 && currData.weight > 0 && currData.distributor_id > 0 && currData.ship_to !== '') &&
            <Grid item sm={12} style={{ textAlign: 'right' }}>
              <Button variant="contained" color="success" onClick={() => saveRecord()}>Create Return</Button>
            </Grid>
          }

          <OrderFormShippingRates
            isRecordSaved={savedRecord && !isDataChanged}
            shipmentId={currData.shipment_id}
            rates={currData.rates}
            rateId={currData.rate_id}
            labelUrl={currData.label_url}
            onChange={(shipmentId, rateId, doSaveRecord) =>
              handleCurrDataChanges({ shipment_id: shipmentId, rate_id: rateId, label_url: '' }, doSaveRecord)}
            easyPostCreateShipment={easyPostCreateShipment}
            easyPostConfirmRateBuildLabel={easyPostConfirmRateBuildLabel}
          />

          <OrderFormPrintSendOptions
            isReadyToPrint={!!(savedRecord && savedRecord.id && currData.label_url !== '')}
            data={currData}
            onEmailsChange={handleEmailsChange}
            addingEmailAction={addingEmailAction}
            setAddingEmailAction={setAddingEmailAction}
            addingEmailAddress={addingEmailAddress}
            setAddingEmailAddress={setAddingEmailAddress}
            printType={printType}
            setPrintType={setPrintType}
            downloadLabelPDF={downloadLabelPDF}
            sendEmails={sendEmails}
          />

        </React.Fragment>
      }

    </Grid >
  );
}

export default OrderForm;
